document.addEventListener("DOMContentLoaded", function () {

  /* ===========================
     Sticky Header
  =========================== */

  const header = document.querySelector(".ol-header");

  if (header) {

    window.addEventListener("scroll", function () {

      if (window.scrollY > 40) {

        header.classList.add("scrolled");

      } else {

        header.classList.remove("scrolled");

      }

    });

  }


  /* ===========================
     Search Popup
  =========================== */

  const popup = document.getElementById("searchPopup");
  const openBtn = document.querySelector(".search-btn");
  const closeBtn = document.getElementById("closeSearch");

  if (openBtn && popup) {

    openBtn.addEventListener("click", function (e) {

      e.preventDefault();

      popup.classList.add("active");

    });

  }

  if (closeBtn && popup) {

    closeBtn.addEventListener("click", function () {

      popup.classList.remove("active");

    });

  }


  /* ===========================
     Mobile Menu
  =========================== */

  const menu = document.getElementById("mobileMenu");
  const menuBtn = document.getElementById("menuBtn");
  const closeMenu = document.querySelector(".close-menu");

  if (menuBtn && menu) {

    menuBtn.addEventListener("click", function () {

      menu.classList.add("active");

    });

  }

  if (closeMenu && menu) {

    closeMenu.addEventListener("click", function () {

      menu.classList.remove("active");

    });

  }

});